import script from "./UpLogArea.vue?vue&type=script&lang=ts&setup=true"
export * from "./UpLogArea.vue?vue&type=script&lang=ts&setup=true"

import "./UpLogArea.vue?vue&type=style&index=0&id=34f45a31&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-34f45a31"]])

export default __exports__